import React from "react";
import { Product } from "../types/product.tsx";

interface ProductAccordionProps {
	product: Product;
	onSelect: (product: Product) => void;
}

const ProductAccordion = ({ product, onSelect }: ProductAccordionProps) => {
	return (
		<div className="card">
			<div className="main-img">
				<img src={product.thumbnail} alt={product.name}	/>
			</div>
			<div className="simple-info">
				<div id="name-is">
					<div id="name">{product.name}</div>
					<div id="available" data-available={product.available}>{product.available ? "🟢" : "🚫"}</div>
				</div>
				<button className="btn_detail" onClick={() => onSelect(product)}>Details</button>
			</div>
		</div>
	);
};

export default ProductAccordion;